import React from "react";
import { CLINIC } from "@/lib/content";
import { MapPin, Phone, Mail, Clock, Instagram, Facebook } from "lucide-react";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="bg-[#0d3a4a] text-[#faf9f6]/85"
        >
            <div className="mx-auto max-w-7xl px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
                <div className="md:col-span-2">
                    <div className="flex items-baseline gap-2">
                        <span className="font-serif-display text-4xl text-[#faf9f6]">
                            Galaxy
                        </span>
                        <span className="text-[11px] uppercase tracking-[0.35em] text-[#d4af37]">
                            Dental Clinic
                        </span>
                    </div>
                    <p className="mt-5 max-w-md text-[#faf9f6]/70 leading-relaxed">
                        {CLINIC.tagline}. A calm, contemporary practice
                        blending master craftsmanship with modern
                        dentistry — right in the heart of Udaipur.
                    </p>
                    <div className="mt-6 flex items-center gap-3">
                        <a
                            href="https://instagram.com"
                            target="_blank"
                            rel="noreferrer"
                            data-testid="footer-instagram"
                            className="h-10 w-10 rounded-full border border-[#faf9f6]/25 flex items-center justify-center hover:border-[#d4af37] hover:text-[#d4af37] transition"
                        >
                            <Instagram size={16} strokeWidth={1.5} />
                        </a>
                        <a
                            href="https://facebook.com"
                            target="_blank"
                            rel="noreferrer"
                            data-testid="footer-facebook"
                            className="h-10 w-10 rounded-full border border-[#faf9f6]/25 flex items-center justify-center hover:border-[#d4af37] hover:text-[#d4af37] transition"
                        >
                            <Facebook size={16} strokeWidth={1.5} />
                        </a>
                    </div>
                </div>

                <div>
                    <h4 className="text-xs uppercase tracking-[0.3em] text-[#d4af37] mb-4">
                        Visit
                    </h4>
                    <ul className="space-y-3 text-sm text-[#faf9f6]/75">
                        <li className="flex gap-3">
                            <MapPin
                                size={16}
                                strokeWidth={1.5}
                                className="mt-0.5 shrink-0 text-[#d4af37]"
                            />
                            <span>{CLINIC.address}</span>
                        </li>
                        <li className="flex gap-3">
                            <Clock
                                size={16}
                                strokeWidth={1.5}
                                className="mt-0.5 shrink-0 text-[#d4af37]"
                            />
                            <span>{CLINIC.hours}</span>
                        </li>
                    </ul>
                </div>

                <div>
                    <h4 className="text-xs uppercase tracking-[0.3em] text-[#d4af37] mb-4">
                        Connect
                    </h4>
                    <ul className="space-y-3 text-sm text-[#faf9f6]/75">
                        <li className="flex gap-3">
                            <Phone
                                size={16}
                                strokeWidth={1.5}
                                className="mt-0.5 shrink-0 text-[#d4af37]"
                            />
                            <a
                                href={`tel:${CLINIC.phoneRaw}`}
                                data-testid="footer-phone"
                            >
                                {CLINIC.phone}
                            </a>
                        </li>
                        <li className="flex gap-3">
                            <Mail
                                size={16}
                                strokeWidth={1.5}
                                className="mt-0.5 shrink-0 text-[#d4af37]"
                            />
                            <a
                                href={`mailto:${CLINIC.email}`}
                                data-testid="footer-email"
                            >
                                {CLINIC.email}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="border-t border-[#faf9f6]/10">
                <div className="mx-auto max-w-7xl px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#faf9f6]/55">
                    <p>
                        © {new Date().getFullYear()} Galaxy Dental Clinic,
                        Udaipur. All rights reserved.
                    </p>
                    <p>
                        Crafted with care in Udaipur ·{" "}
                        <a
                            href="/admin/login"
                            data-testid="footer-admin-link"
                            className="hover:text-[#d4af37]"
                        >
                            Staff Login
                        </a>
                    </p>
                </div>
            </div>
        </footer>
    );
}
